/* ==========================================================
   Unisource Create Design Bridge
   Asset: unisource-create-design-bridge.js

   Purpose:
   Detects this URL:
   /pages/design-inspiration-center?open=create-design&productId=1010293&styleId=1016505

   Then launches the same Unisource InkSoft Design Studio path.
========================================================== */

(function () {
  "use strict";

  var BRIDGE_DEBUG = true;

  function log() {
    if (!BRIDGE_DEBUG) return;
    try {
      console.log.apply(console, ["[Create Design Bridge]"].concat(Array.prototype.slice.call(arguments)));
    } catch (error) {}
  }

  function clean(value) {
    return String(value || "").trim();
  }

  function getParams() {
    try {
      return new URLSearchParams(window.location.search || "");
    } catch (error) {
      return new URLSearchParams();
    }
  }

  function getParam(name) {
    return clean(getParams().get(name));
  }

  function shouldLaunch() {
    return getParam("open") === "create-design";
  }

  function getContext() {
    return {
      productId: getParam("productId") || getParam("product") || "1010293",
      styleId: getParam("styleId") || getParam("style") || "1016505",
      designId: getParam("designId") || getParam("design") || ""
    };
  }

  function buildBlankDesignStudioUrl(productId, styleId) {
    if (!productId || !styleId) return "";

    return (
      "https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/share/" +
      encodeURIComponent(productId) +
      "/" +
      encodeURIComponent(styleId)
    );
  }

  function buildTemplateDesignStudioUrl(productId, styleId, designId) {
    if (!productId || !styleId || !designId) {
      return buildBlankDesignStudioUrl(productId, styleId);
    }

    return (
      "https://shop.unisourceapparel.com/Unisource_Apparel/shop/design-studio/share/" +
      encodeURIComponent(productId) +
      "/" +
      encodeURIComponent(styleId) +
      "?designId=" +
      encodeURIComponent(designId)
    );
  }

  function setStatus(message, type) {
    var status =
      document.querySelector("[data-design-status]") ||
      document.querySelector("[data-design-inspiration-status]") ||
      document.querySelector(".unisource-design-inspiration__status") ||
      document.querySelector(".unisource-design-status");

    if (!status) {
      log("Status element not found:", message);
      return;
    }

    status.hidden = false;
    status.textContent = message;

    if (type) {
      status.setAttribute("data-status", type);
    }
  }

  function openWithExistingEmbed(context, launchUrl) {
    if (
      window.InksoftPOC &&
      window.InksoftPOC.designerEmbed &&
      typeof window.InksoftPOC.designerEmbed.open === "function"
    ) {
      log("Opening with window.InksoftPOC.designerEmbed.open");

      window.InksoftPOC.designerEmbed.open({
        productId: context.productId,
        styleId: context.styleId,
        designId: context.designId || "",
        templateDesignId: context.designId || "",
        launchUrl: launchUrl,
        shareUrl: launchUrl,
        selectedShareUrl: launchUrl,
        wrapperUrl: ""
      });

      return true;
    }

    return false;
  }

  function findExistingDesignOnlineButton() {
    return (
      document.querySelector("[data-design-online]") ||
      document.querySelector("[data-design-online-button]") ||
      document.querySelector("[data-design-studio-open]") ||
      document.querySelector(".unisource-design-online") ||
      document.querySelector(".unisource-design-studio-open")
    );
  }

  function openWithExistingButton() {
    var button = findExistingDesignOnlineButton();

    if (!button) return false;

    log("Opening with existing Design Online button");
    button.click();
    return true;
  }

  function removeCreateDesignQueryFromUrl() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete("open");
      window.history.replaceState({}, document.title, url.toString());
    } catch (error) {}
  }

  function redirectToInkSoft(launchUrl) {
    log("Redirecting to InkSoft URL:", launchUrl);
    window.location.href = launchUrl;
  }

  function launchBridge() {
    if (!shouldLaunch()) {
      log("No create-design request detected.");
      return;
    }

    var context = getContext();

    log("Create design request detected:", context);

    if (!context.productId || !context.styleId) {
      setStatus(
        "Unable to open Design Studio. Product ID or Style ID is missing.",
        "error"
      );

      console.error("[Create Design Bridge] Missing product/style values:", context);
      return;
    }

    var launchUrl = context.designId
      ? buildTemplateDesignStudioUrl(context.productId, context.styleId, context.designId)
      : buildBlankDesignStudioUrl(context.productId, context.styleId);

    if (!launchUrl) {
      setStatus("Unable to prepare Design Studio launch URL.", "error");
      return;
    }

    setStatus("Preparing Design Studio...", "running");

    /*
      Wait for the Design Inspiration Center scripts to finish loading.
      Some Shopify pages load assets slowly, so this checks for up to 15 seconds.
    */
    var attempts = 0;
    var maxAttempts = 60;

    var timer = window.setInterval(function () {
      attempts += 1;

      if (openWithExistingEmbed(context, launchUrl)) {
        window.clearInterval(timer);
        setStatus("Design Studio opened.", "success");
        removeCreateDesignQueryFromUrl();
        return;
      }

      /*
        Secondary option:
        If the page has a native Design Online button already rendered,
        use that behavior instead.
      */
      if (attempts >= 8 && openWithExistingButton()) {
        window.clearInterval(timer);
        setStatus("Design Studio opened.", "success");
        removeCreateDesignQueryFromUrl();
        return;
      }

      /*
        Final fallback:
        Redirect to the correct Unisource InkSoft Design Studio URL.
      */
      if (attempts >= maxAttempts) {
        window.clearInterval(timer);

        console.warn(
          "[Create Design Bridge] Embedded designer object was not found. Falling back to direct InkSoft launch.",
          launchUrl
        );

        setStatus("Opening Design Studio...", "running");
        redirectToInkSoft(launchUrl);
      }
    }, 250);
  }

  function boot() {
    /*
      Slight delay lets design-inspiration.js initialize first.
    */
    window.setTimeout(launchBridge, 600);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();